import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #ACCORDION
\*------------------------------------ */
dl.cat-c-accordion {
  margin: 0;
}

/**
 * Inverted accordion
 * 1) Used for dark backgrounds. Passes color down via custom properties
 * for easy use by consumers
 */
.cat-c-accordion--inverted {
  color: var(--cat-theme-color-content-knockout);
  --cat-accordion-panel-border-color: var(--cat-theme-color-border-knockout);
  --cat-accordion-panel-hover-background: var(--cat-theme-color-background-strong);
  --cat-accordion-panel-background: none;
}

::slotted(cat-accordion-panel:not([disabled])) {
  border-block-end: var(--cat-border-width-sm) solid var(--cat-accordion-panel-border-color, var(--cat-theme-color-border-default));
}

::slotted(cat-accordion-panel:hover:not([disabled])) {
  border-block-end: var(--cat-border-width-sm) solid var(--cat-accordion-panel-border-color, var(--cat-theme-color-border-default-hover));
}

::slotted(cat-accordion-panel:first-child:not([disabled])) {
  border-block-start: var(--cat-border-width-sm) solid var(--cat-accordion-panel-border-color, var(--cat-theme-color-border-default));
}

::slotted(cat-accordion-panel:first-child:hover:not([disabled])) {
  border-block-start: var(--cat-border-width-sm) solid var(--cat-accordion-panel-border-color, var(--cat-theme-color-border-default-hover));
}

::slotted(cat-accordion-panel[disabled]) {
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-disabled);
}

::slotted(cat-accordion-panel:first-child[disabled]) {
  border-block-start: var(--cat-border-width-sm) solid var(--cat-theme-color-border-disabled);
}
`;
       